<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
                <h4 class="m-0 mx-auto"> {{ $t("experience") }} </h4>
            </div>
            <div class="row">
                <div class="sections p-3">
                    <div class="card w-100 border-0">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-1">
                                    <img src="@/assets/images/nokhbegan.png" class="place-logos" alt="tmr">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("member") }} </span>
                                        <span class="d-block" v-html="$t('nef')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("nef_date") }} </small>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-3">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-1">
                                    <img src="@/assets/images/tmr.jpeg" class="place-logos" alt="tmr">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("reviewer") }} <small>({{ $t("full_time") }})</small> </span>
                                        <span class="d-block" v-html="$t('tmr')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("tmr_date") }} </small>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-3">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-1">
                                    <img src="@/assets/images/yerc.png" class="place-logos" alt="tmr">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("member") }} </span>
                                        <span class="d-block" v-html="$t('yerc')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("yerc_date") }} </small>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="text-center">
                        <vs-button class="d-inline mt-3" transparent active color="dark" data-toggle="collapse" data-target="#collapseExperience" aria-expanded="false" aria-controls="collapseExperience">
                            {{ $t("more") }}
                        </vs-button>
                    </div>
                    <div class="collapse" id="collapseExperience">
                        <div class="card w-100 border-0 mt-3">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-1">
                                        <img src="@/assets/images/hospitals.png" class="place-logos" alt="hospitals">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("scientist") }} <small>({{ $t("full_time") }})</small> </span>
                                            <span class="d-block"> {{ $t("hospitals") }} </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right">
                                    <div class="ltr">
                                        <small> {{ $t("hospitals_date") }} </small>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-3">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-1">
                                        <img src="@/assets/images/journal.png" class="place-logos" alt="journal">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("editor") }} </span>
                                            <span class="d-block" v-html="$t('ghasedak')"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right">
                                    <small> {{ $t("ghasedak_date") }} </small>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <vs-dialog v-model="active1" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"> <a href="https://abolfazlmohajeri.ir" target="_blank"> abolfazlmohajeri.ir </a> </li>
                <li class="list-group-item"><a href="https://traceit.ir" target="_blank"> traceit.ir </a></li>
                <li class="list-group-item"><a href="https://rabassa.ir" target="_blank"> rabassa.ir </a></li>
                <li class="list-group-item"><a href="https://placeyourad.ir" target="_blank"> placeyourad.ir </a></li>
                <li class="list-group-item"> <a href="https://server.abolfazlmohajeri.ir" target="_blank"> server.abolfazlmohajeri.ir </a> (Vps and Self Hosted Projects) </li>
                <li class="list-group-item"> Participated in a Lot of Freelancing Projects  </li>
            </ul>
        </vs-dialog>

        <vs-dialog v-model="active2" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"> <a href="http://mobintabaran.ir" target="_blank"> mobintabaran.ir </a> </li>
                <li class="list-group-item"> <a href="http://linetab.ir" target="_blank"> linetab.ir </a> </li>
            </ul>
        </vs-dialog>

        <vs-dialog v-model="active3" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"><a href="https://quera.org" target="_blank"> quera.org </a></li>
                <li class="list-group-item"> <a href="https://codecup.ir" target="_blank"> codecup.ir </a> </li>
            </ul>
        </vs-dialog>

        <vs-dialog v-model="active4" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"><a href="https://neshan.org" target="_blank"> neshan.org </a></li>
            </ul>
        </vs-dialog>
    </div>
</template>

<script>
    export default {
        name: "Experience",
        data() {
            return {
                language: this.$i18n.locale,
                active1: false,
                active2: false,
                active3: false,
                active4: false
            }
        },
        mounted() {

        },
        methods : {

        }
    }
</script>

<style>

</style>

<style scoped>

</style>
